import { AxiosError } from 'axios';
import { UserProfile, Folder, Image } from '../models';

export const isNullOrWhitespace = (input: string | null | undefined): boolean => {
	if (input === undefined) return true;
	if (input === null) return true;
	if (input === '') return true;
	if (input.trim() === '') return true;
	return false;
};

export const getInitials = (user: UserProfile | null): string => {
	if (user === null) return '';
	return `${user.firstName ? user.firstName[0] : ''}${user.lastName ? user.lastName[0] : ''}`;
};

export const getSimpleName = (user: UserProfile | null): string => {
	if (user === null) return '';
	const simple = user.uniqueName.replace('@empire-today.com', '').replace('EMPIRE\\', '');
	return `${simple}@empire-today.com`;
};

export const parseException = (error: any): Error => {
	if (!error) return new Error('An Unknown Error Has Occured');
	if (!error.isAxiosError) return new Error(error);
	const axiosError = error as AxiosError;
	if (axiosError.response) {
		if (axiosError.response.data && axiosError.response.data) {
			if (typeof axiosError.response.data === 'string') {
				return new Error(axiosError.response.data);
			} else {
				const data = axiosError.response.data as { detail?: string; title?: string; message?: string };
				return new Error(data.detail ?? data.title ?? data.message ?? 'An Unknown Error Has Occured');
			}
		}
	}
	if (axiosError.message) {
		return new Error(axiosError.message);
	}
	return new Error(error);
};

export const getParentFoldersForImage = (allFolders: Folder[], image: Image): Folder[] => {
	let folders = [] as Folder[];
	let parentFolder = allFolders.find(f => f.id === image.folderId);

	if (parentFolder) {
		folders.push(parentFolder);
		folders.push.apply(folders, getParentFoldersForFolder(allFolders, parentFolder));
	}

	return folders;
};

export const getParentFoldersForFolder = (allFolders: Folder[], folder: Folder): Folder[] => {
	let folders = [] as Folder[];
	folders.push(folder);
	let parentFolder = allFolders.find(f => f.id === folder.parentId);

	while (parentFolder) {
		folders.push(parentFolder);
		parentFolder = allFolders.find(f => f.id === (parentFolder ? parentFolder.parentId : ''));
	}

	return folders;
};